







import LoginCard from "@/components/elements/other/LoginCard.vue";
import AppointmentOnlineCard from "@/components/elements/other/AppointmentOnlineCard.vue";
import {Component, Vue} from 'vue-property-decorator';
import {AuthModule} from "@/store/modules/auth";


@Component({
  components: {AppointmentOnlineCard, LoginCard}
})
export default class TopCard extends Vue {


  get isAuthenticated() {
    return AuthModule.isAuthenticated
  }
}
